import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, ShieldCheck, ChevronRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';

/**
 * Honor — v4.1 Phase 10C rebrand.
 *
 * The legacy /honor page was built around a Polish border-enforcement
 * donation pledge (10% of every Premium subscription). Under the v4.0
 * doctrine ("European immigration record integrity infrastructure"),
 * HussarAi must remain politically and institutionally neutral — no
 * border-enforcement, no patriotic-funding, no donation framing.
 *
 * The page is preserved at /honor for backlink continuity but is
 * rewritten from scratch into a neutral responsibility / accountability
 * card that anchors the same values: transparency, human review, no
 * automated immigration decisions.
 *
 * No backend calls — the page renders purely from i18n.
 */
const Honor = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="hussar-app">
      <header className="hussar-app-header">
        <div className="hussar-app-header-content">
          <Button
            variant="ghost"
            className="hussar-btn-back"
            onClick={() => navigate('/')}
            data-testid="honor-back-btn"
          >
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <div className="hussar-logo-full" onClick={() => navigate('/')}>
            <img src="/hussarai-logo-full.png" alt="HussarAi" className="hussar-logo-full-img-small" />
          </div>
          <div></div>
        </div>
      </header>

      <div className="hussar-honor-page" data-testid="honor-page">
        <div className="hussar-honor-container">
          <div className="hussar-honor-hero">
            <div className="hussar-honor-shield" aria-hidden="true">
              <ShieldCheck className="w-12 h-12" />
            </div>
            <h1 className="hussar-honor-title" data-testid="honor-page-title">
              {t('honor.pageTitle')}
            </h1>
            <p className="hussar-honor-subtitle" data-testid="honor-page-subtitle">
              {t('honor.pageSubtitle')}
            </p>
          </div>

          <Card className="hussar-honor-card hussar-honor-mission" data-testid="honor-page-mission">
            <p>{t('honor.pageMission')}</p>
          </Card>

          <section className="hussar-honor-cta" data-testid="honor-cta">
            <h2 className="hussar-honor-cta-title">{t('honor.ctaTitle')}</h2>
            <p className="hussar-honor-cta-text">{t('honor.ctaText')}</p>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
              <Button
                onClick={() => navigate('/bezpieczenstwo-i-zgodnosc')}
                className="hussar-btn-primary hussar-btn-large"
                data-testid="honor-cta-security-btn"
              >
                {t('honor.ctaButton')}
                <ChevronRight className="w-5 h-5" />
              </Button>
              <Button
                variant="outline"
                onClick={() => navigate('/review-akt-imigracyjnych')}
                data-testid="honor-cta-review-demo-btn"
              >
                {t('honor.ctaSecondary')}
              </Button>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Honor;
